import type { Spec} from 'immutability-helper2';
import imupdate, {extend} from 'immutability-helper2'

type AnyCallback = (value: any, idx: number) => any

extend('$removeWhere', function(func: AnyCallback, array: any) {
    return array.filter((el: any, idx: any) => !func(el, idx))
})

// extend('$map', (callback: AnyCallback, array: any[]) => array.map((el, idx) => callback(el, idx)))

// extend('$mapMerge', (callback: AnyCallback, array: any[]) => array.map((el, idx) => ({...el, ...callback(el, idx)})))


export default function immutableUpdate<T>($spec: Spec<T>, object: T): T;
export default function immutableUpdate<T>($spec: Spec<T>): (object: T) => T;
export default function immutableUpdate<T>($spec: Spec<T>, object?: T) {
    return object === undefined
        ? (object: T) => imupdate(object, $spec)
        : imupdate(object, $spec)
}


export type {Spec}
